import React, { useEffect, useState } from 'react'
import { IconButton } from '@material-ui/core'
import UpdateIcon from '@material-ui/icons/Update'
import { COLORES } from '../../../config/colores'
import moment from 'moment'

function UltimaActualizacionData (props) {
  const { actualizar, ultimaActualizacion, setUltimaActualizacion, iconColor = COLORES.blue.primaryDark } = props
  // const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, [1000])

    return () => {
      clearInterval(interval)
    }
  }, [setSeconds, seconds])

  const actualizacion = () => {
    setSeconds(30)
    actualizar()
    setUltimaActualizacion(new Date())
  }

  const disabled = seconds > 0

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', margin: '0 1%' }}>
      <IconButton
        onClick={actualizacion}
        disabled={disabled}
        style={{ padding: 0 }}
      >
        <UpdateIcon style={{ color: disabled ? COLORES.grey.clear : iconColor }} />
      </IconButton>
      {ultimaActualizacion && <p
        style={{
          textAlign: 'right',
          margin: '0 5px',
          padding: 0
        }}
      >
            Última actualización: {moment(ultimaActualizacion).format('DD-MM-YYYY HH:mm')}
      </p>
      }
    </div>
  )
}

export default UltimaActualizacionData
